
import { useContext } from 'react'

import { Error, Row, Spacer, Footer } from 'components/ui/form/Form'
import { ModalContext } from 'context/ModalContext'
import KitPartsInput from './KitPartsInput'
import { InputFormik, Button } from 'components/gsys-ui'
import { CheckIcon, XMarkIcon } from '@heroicons/react/24/outline'

const KitForm = ({ isSubmitting, handleSubmit, error }) => {
  const modal = useContext(ModalContext)

  return (
    <>
      <Error>{error}</Error>
      <Row>
        <InputFormik name="name" label="Kit name" />
        <InputFormik name="code" label="Code" />
      </Row>
      <Spacer />
      <Row>
        <KitPartsInput name="items" />
      </Row>
      <Footer>
        <Button variant="white" onClick={modal.close}>
          <XMarkIcon className="mr-1 w-5 h-5" />
          Cancel
        </Button>
        <Button variant="green" onClick={handleSubmit} loading={isSubmitting}>
          <CheckIcon className="mr-1 w-5 h-5" />
          Submit
        </Button>
      </Footer>
    </>
  )
}

export default KitForm